import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Bike, Car, MapPinned } from "lucide-react";
import { waLink } from "@/lib/api";

const options = [
  { icon: Bike, label: "Book a scooter now", msg: "Hi Random Rider! I want to book a scooter/bike rental in Puri.", testId: "whatsapp-option-scooter" },
  { icon: Car, label: "Enquire outstation taxi", msg: "Hi Random Rider! I need an outstation cab from Puri (₹20/km + tolls/parking/night halt at actuals).", testId: "whatsapp-option-taxi" },
  { icon: MapPinned, label: "Talk to a local guide", msg: "Hi Random Rider! I'd like to talk to a local guide about Puri sightseeing.", testId: "whatsapp-option-guide" },
];

export default function WhatsAppDock() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-6 right-6 z-[80] flex flex-col items-end gap-3" data-testid="whatsapp-dock">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            transition={{ duration: 0.25 }}
            className="bg-white rounded-2xl shadow-2xl border border-ink/10 p-2 w-64"
            data-testid="whatsapp-dock-menu"
          >
            {options.map((o) => (
              <a
                key={o.label}
                href={waLink(o.msg)}
                target="_blank"
                rel="noreferrer"
                data-testid={o.testId}
                className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-sand text-sm font-medium text-ink transition-colors"
              >
                <o.icon size={17} className="text-terra" /> {o.label}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
      <button
        onClick={() => setOpen(!open)}
        data-testid="whatsapp-float-button"
        aria-label="WhatsApp quick contact"
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        {open ? <X size={24} /> : <MessageCircle size={26} />}
      </button>
    </div>
  );
}
